// El final del onboarding de marca para quien lo debía por empezar a pagar
// (ADR-2026-10-31-onboarding-corto-para-la-prueba).
//
// Dos cosas al tocar "Entrar a Atlas":
//   · la base deja de decir que lo debe. Tiene que quedar escrito ANTES de salir: si no, el
//     rebote de la próxima carga lo devuelve al principio de un onboarding que ya hizo.
//   · la llamada de capacitación, si el plan la incluye, va AHORA: el pago ya no la muestra
//     primero cuando hay onboarding de marca de por medio.

import { supabase } from '../supabase';
import { onboardingDeMarcaCompletado } from '../cuestionarioObligatorio';
import { incluyeLlamadaDeCapacitacion } from '../checkoutPlans';
import { V2_STUDIO_PATH } from '../userGroups';

export const INTENTOS_AL_TERMINAR = 3;

/** `true` si la base ya no dice que lo debe. Con `true` también se apaga el flag en memoria. */
export async function marcarOnboardingDeMarcaHecho(companyId: string): Promise<boolean> {
  for (let i = 0; i < INTENTOS_AL_TERMINAR; i++) {
    try {
      const { error } = await supabase
        .from('company_profiles')
        .update({ debe_onboarding_marca: false })
        .eq('id_company', companyId);
      if (!error) {
        onboardingDeMarcaCompletado();
        return true;
      }
    } catch {
      /* se reintenta */
    }
  }
  return false;
}

/**
 * Adónde sigue. `conFacturacion: false` porque la oferta de factura ya pasó antes del
 * onboarding: la pantalla de la llamada no la vuelve a encadenar.
 */
export function destinoAlTerminar(plan: string | null | undefined): { ruta: string; state?: Record<string, unknown> } {
  if (plan && incluyeLlamadaDeCapacitacion(plan)) {
    return { ruta: '/capacitacion-ultra', state: { postPago: true, plan, conFacturacion: false } };
  }
  return { ruta: V2_STUDIO_PATH };
}
